
import React from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

// Create a proper Google icon
const GoogleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 48 48" 
    width="24" 
    height="24" 
    className={className}
    fill="none"
  >
    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
  </svg>
);

interface GoogleSignInProps {
  onLoginSuccess: (user: any) => void;
}

const GoogleSignIn = ({ onLoginSuccess }: GoogleSignInProps) => {
  const handleGoogleSignIn = async () => {
    try {
      console.log("Starting Google sign-in process...");
      
      // Get the current deployment URL for proper redirects
      const deploymentUrl = window.location.origin;
      
      // Ensure redirect URL always goes to the /login path
      const redirectTo = `${deploymentUrl}/login`;
      
      console.log("Redirect URL:", redirectTo);
      
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: redirectTo,
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          }
        },
      });
      
      if (error) {
        console.error('Google sign in error:', error);
        toast.error(`Google sign in failed: ${error.message}`);
        throw error;
      }
      
      toast.success("Redirecting to Google...");
      console.log("Redirecting to Google auth with URL:", data?.url);
      
      // Redirect the user to the authentication URL
      if (data?.url) {
        window.location.href = data.url;
      }
      
      // The onLoginSuccess will be called after redirect and authentication
      // when the user returns to the app
    } catch (error) {
      console.error('Google sign in error:', error);
      toast.error("Google sign in failed. Please check console for details.");
    }
  };

  return (
    <Button 
      onClick={handleGoogleSignIn}
      className="flex items-center gap-2 bg-white text-gray-800 hover:bg-gray-100 w-full transition-colors"
      variant="outline"
    >
      <GoogleIcon className="h-5 w-5" />
      <span>Sign In with Google</span>
    </Button>
  );
};

export default GoogleSignIn;
